import { render, staticRenderFns } from "./MainHome.vue?vue&type=template&id=649fa883&scoped=true&"
import script from "./MainHome.vue?vue&type=script&lang=js&"
export * from "./MainHome.vue?vue&type=script&lang=js&"
import style0 from "./MainHome.vue?vue&type=style&index=0&id=649fa883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649fa883",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
